import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteRepresentative } from '../../actions/user-api';
import $ from 'jquery';

export const DeleteModal = ({ referent }) => {
    const user = useSelector(state => state.user);
    const [deleteAttempt, setDeleteAttempt] = useState(false);
    const dispatch = useDispatch();

    const hideModal = () => { $('.modal').modal('hide'); };

    useEffect(() => {
        if (user.isDeletingReferent === false && deleteAttempt === true) {
            if (user.referents.findIndex(r => r.id === referent.id) === -1) {
                setTimeout(() => {
                    hideModal();
                }, (100));
            }
            setDeleteAttempt(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.isDeletingReferent]);


    return (
        <div className="modal fade px-0" id="deleteReferent" aria-labelledby="deleteReferentLabel" aria-hidden="true">
            <div className="modal-dialog px-2 modal-sm">
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="alert alert-danger rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
                            <h5 className="sr-only visually-hidden">Supprimer mandataire</h5>
                            <div className="flex-row align-items-center justify-content-between">
                                <div className="h4 font-weight-demi text-danger text-uppercase mb-0 ls-n1 lh-1 mx-auto" id="infoValiderLabel">Supprimer le mandataire</div>
                                <button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
                                    <i className="eva eva-close fs-4"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="modal-body scroll-default py-0">
                        <div className="h2 lh-copy">Supprimer le mandataire?</div>
                        <div className="o-80 mt-2">Ce mandataire est sur le point d'être supprimé. Veuillez confirmer cette action.</div>
                        <div className="fs-3 o-80 text-danger"><b className="font-weight-black">AVERTISSEMENT</b>: cette action est irréversible.</div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-light mr-2" data-dismiss="modal">Annuler</button>
                        <button className={"btn btn-danger" + (deleteAttempt === true || user.isDeletingReferent === true ? ' disabled' : '')}
                            onClick={() => {
                                if (deleteAttempt === false && user.isDeletingReferent === false) {
                                    setDeleteAttempt(true);
                                    dispatch(deleteRepresentative(referent));
                                }
                            }}>
                            Oui, supprimer le mandataire
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}